import TalentTestimonials from "./TalentTestimonials.vue"

export default function install(Vue) {
  Vue.component(TalentTestimonials.name, TalentTestimonials)
}
